<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">提示</div>
<div class="subtitle">* 点击图片查看详细大图</div>
<div class="content">
  <div class="text">登陆时需要选择加入团队</div>
  <div class="img">
    <img
      src="../../../../assets/images/adobe/img_1.png"
      width="auto"
      [height]="96"
      alt=""
      (click)="openImage($event)"
    />
    <img
      src="../../../../assets/images/adobe/img_2.png"
      width="auto"
      [height]="96"
      alt=""
      (click)="openImage($event)"
    />
    <img
      src="../../../../assets/images/adobe/img_3.png"
      width="auto"
      [height]="96"
      alt=""
      (click)="openImage($event)"
    />
  </div>
  <div class="text">若提示“完成您的账户”按照下图填写</div>
  <div class="img">
    <img
      src="../../../../assets/images/adobe/img_4.png"
      width="auto"
      [height]="96"
      alt=""
      (click)="openImage($event)"
    />
  </div>
  <div class="text">登入需要验证码，</div>
  <div class="text">请点击车票最下方的获取验证码，</div>
  <div class="text">自助获取</div>
</div>

<ng-container *ngIf="isModalOpen">
  <div class="modal" (click)="closeModal()">
    <img [src]="selectedImage" alt="Enlarged Image" />
  </div>
</ng-container>
